




























































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';

import { Component, Watch } from 'vue-property-decorator';
import { DownloadIcon, HashIcon, LayoutIcon, PlusIcon, UploadCloudIcon } from 'vue-feather-icons';
import {
  DateFilter,
  IPolicy,
  IProduct,
  PolicyFilter,
  PolicyFilterDto,
  PolicyStatus,
} from 'admiral-core';
import PoliciesOverview from '@/views/pages/policies/PoliciesOverview.vue';
import { PolicyApi } from '@/services/PolicyApi';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import PolicyProductCard from '@/views/pages/policies/PolicyProductCard.vue';
import PolicyResultsSummaryCard from '@/views/pages/policies/PolicyResultsSummaryCard.vue';
import {
  calculatePolicyResults,
  emptyPolicyResults,
  PolicyResults,
} from '@/utils/calculatePolicyResults';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';
import CreatePolicyModal from '@/views/pages/policies/CreatePolicyModal.vue';
import ImportPoliciesButton from '@/views/pages/policies/ImportPoliciesButton.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { Util } from '@/utils/Util';
import { BModal } from 'bootstrap-vue';
import TransferOpenPoliciesModal from '@/views/pages/policies/TransferOpenPoliciesModal.vue';

interface Video {
  url: string;
  title: string;
  text: string;
}

@Component({
  components: {
    ImportPoliciesButton,
    CreatePolicyModal,
    PolicyStatusSelect,
    PolicyProductCard,
    PolicyResultsSummaryCard,
    HorizontalPolicyStatusSelect,
    PolicyStatusBadge,
    PlusIcon,
    PoliciesOverview,
    HashIcon,
    LayoutIcon,
    UploadCloudIcon,
    DownloadIcon,
    TransferOpenPoliciesModal,
  },
})
export default class AllPolicies extends mixins(BaseMixin, PermissionMixin) {
  policies: IPolicy[] = [];

  isLoading = false;
  results: PolicyResults = emptyPolicyResults();

  selectedVideo: Video | null = null;

  async reload() {
    const filter = this.$store.getters[`PreferencesModule/getPolicyFilter`] as PolicyFilter;

    await this.loadPolicies(filter as PolicyFilterDto);
  }

  async submitted() {
    await this.reload();
    this.$root.$emit('on-submit-create-policy');
  }

  get firstVisitAt() {
    return this.$store.getters[`PreferencesModule/getFirstVisitAt`] as Date | null;
  }

  get firstVisitAfterV12() {
    return this.$store.getters[`PreferencesModule/getFirstVisitAfterV12`] as Date | null;
  }

  async mounted() {
    // this.selectedVideo = this.videos['firstVisitAt'];
    // if (!this.firstVisitAt) {
    //   this.selectedVideo = this.videos['firstVisitAt'];
    //
    //   (this.$refs['show-video'] as BModal).show();
    //   await this.$store.dispatch('PreferencesModule/updateFirstVisit');
    // } else if (!this.firstVisitAfterV12) {
    //   this.selectedVideo = this.videos['firstVisitAfterV12'];
    //
    //   (this.$refs['show-video'] as BModal).show();
    //   await this.$store.dispatch('PreferencesModule/updateFirstVisitAfterV12');
    // }
    // const filter = this.$store.getters[`PreferencesModule/getPolicyFilter`] as PolicyFilter;
    // filter.status = [PolicyStatus.OPEN, PolicyStatus.SUBMITTED];

    await this.loadPolicies(this.policyFilter);

    this.$root.$on('change-policy-filter', () => {
      this.loadPolicies(this.policyFilter);
    });
  }

  get policyFilter() {
    return this.$store.getters[`PreferencesModule/getPolicyFilter`];
  }

  @Watch('policyFilter', { deep: true })
  async onPolicyFilterChange() {
    await this.loadPolicies(this.policyFilter);
  }

  async reloadImported() {
    this.policyFilter.status = [PolicyStatus.POLICED, PolicyStatus.CANCELED];
    this.policyFilter.dateFilter = DateFilter.ALL;
    this.policyFilter.users = undefined;
    await this.loadPolicies(this.policyFilter);
  }
  @Watch('$route.name')
  async onRouteChange() {
    if (this.$route.name === 'policies.edit') {
      await this.loadPolicies(this.policyFilter);
    }
  }

  /**
   * Setzt selectedPolicy für policies.edit. Die Anbahnung kann im Listenfilter fehlen
   * (z. B. POLICIERT bei Filter nur OFFEN) – dann per ID laden, nie mit null überschreiben.
   */
  async syncSelectedPolicyForEditRoute() {
    const routeId = this.$route.params.id as string | undefined;
    const overview = this.$refs['policies-overview'] as PoliciesOverview | undefined;
    if (!routeId || !overview) {
      return;
    }

    let selectedPolicy =
      this.policies.find((policy: IPolicy) => policy.id === routeId) || null;

    if (!selectedPolicy) {
      const current = overview.selectedPolicy;
      if (current?.id === routeId && Object.keys(current).length > 0) {
        selectedPolicy = current as IPolicy;
      } else {
        try {
          const response = await PolicyApi.getPolicy(routeId);
          selectedPolicy = response.data;
        } catch (e) {
          console.log(e);
        }
      }
    }

    if (selectedPolicy) {
      overview.selectedPolicy = selectedPolicy;
    }
  }

  async loadPolicies(filter?: PolicyFilterDto) {
    try {
      this.isLoading = true;
      this.$Progress.start();

      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }

      if (!filter.agency) {
        filter.agency = this.user.agency;
      }

      const policies = await PolicyApi.getPolicies({
        ...filter,
        // @ts-ignore
        users: filter.users?.length > 0 ? filter.users : undefined,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });

      this.policies = policies.data as IPolicy[];

      if (this.$route.name === 'policies.edit') {
        await this.syncSelectedPolicyForEditRoute();
      }
      this.calculate();
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }

  /** Aggregiert Stückzahl und Bewertung pro Status und Produkt. */
  calculate() {
    this.results = calculatePolicyResults(this.policies, this.products);
  }
  get isMobile() {
    return Util.isMobile();
  }

  async handleImportPoliciesUpload() {
    // eslint-disable-next-line
    // this.reportFiles = (this.$refs.file as any).files;
    // const formData = new FormData();
    //
    // for (let i = 0; i < this.reportFiles.length; i++) {
    //   formData.append('file' + i, this.reportFiles[i]);
    // }
    //
    // (this.$refs.file as HTMLFormElement).value = '';
  }

  async handleExportPolicies() {
    try {
      let filter = this.policyFilter;
      this.isLoading = true;
      this.$Progress.start();
      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }

      if (!filter.agency) {
        filter.agency = this.user.agency;
      }

      const response = await PolicyApi.exportPolicies({
        ...filter,
        // @ts-ignore
        users: filter.users?.length > 0 ? filter.users : undefined,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'project.csv');
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      this.$toastr.e(
        'Beim Exportieren der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }
}
